import Select from 'react-select';

export default function SelectField({onChange, value, label, options, id, isMulti, ...props}) {
  const valueOption = isMulti ? options.filter((o) => value.includes(o.value)) : options.find((o) => o.value === value)

  function handleChange(options) {
    if (isMulti) {
      onChange(options?.map(o => o.value) || [])
    } else {
      onChange(options?.value)
    }
  }

  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <Select id={id} options={options} value={valueOption} onChange={handleChange} isMulti={isMulti} />
    </div>
  )
}
